<div class="container-fluid d-flex justify-content-center">
  <div class="card-container mt-5">
    <div class="card" style="width: 18rem">
      <div
        class="
          card-header
          d-flex
          justify-content-center
          align-items-center
          flex-column
        "
      >
        <img
          src="./assets/images/logo-xx.png"
          class="card-img-top mt-4"
          alt="..."
        />
        <!-- <h1 class="card-title text-danger mt-3">Version de prueba</h1> -->
        <h5 class="card-subtitle mb-2 text-muted">
          Por favor,Ingresa tu información de usuario
        </h5>
      </div>
      <div class="card-body">
        <form [formGroup]="loginForm">
          <div
            *ngIf="(email?.dirty || email?.touched) && email?.errors"
            class="text-danger"
          >
            <span *ngIf="email?.errors?.required"
              >Email es requerido
              <hr
                style="
                  margin-bottom: 0px;
                  background: transparent;
                  color: transparent;
                "
            /></span>
            <span *ngIf="email?.errors?.email"
              >Escriba un formato de email correcto
              <hr
                style="
                  margin-bottom: 0px;
                  background: transparent;
                  color: transparent;
                "
            /></span>
          </div>

          <div class="input-group mb-3 form__div">
            <input
              type="text"
              class="form-control form__input"
              formControlName="email"
              autocomplete="email"
              placeholder="email"
            />
            <label for="" class="form__label" translate>Email</label>

            <span hidden translate>Email</span>
          </div>
          <div
            *ngIf="(password?.dirty || password?.touched) && password?.errors"
            class="text-danger"
          >
            <span *ngIf="password?.errors?.required"
              >Contraseña es requerida
              <hr
                style="
                  margin-bottom: 0px;
                  background: transparent;
                  color: transparent;
                  margin-top: 0px;
                "
            /></span>
            <span *ngIf="password?.errors?.minlength"
              >Contraseña debe tener al menos 6 caracteres
              <hr
                style="
                  margin-bottom: 0px;
                  background: transparent;
                  color: transparent;
                  margin-top: 0px;
                "
            /></span>
            <br />
          </div>

          <div class="input-group mb-3 form__div">
            <input
              [type]="isPassword ? 'password' : 'text'"
              name="pswd"
              id="myInput"
              class="form-control form__input"
              formControlName="password"
              autocomplete="current-password"
              placeholder="Contraseña"
              required
            />
            <label for="" class="form__label" translate>Contraseña</label>

            <span hidden translate>Contraseña</span>

            <div class="input-group-append">
              <div class="input-group-text">
                <span
                  class="fas fa-eye mr-1 ojo"
                  *ngIf="isPassword"
                  (click)="showPassword()"
                ></span>
                <span
                  class="fas fa-eye-slash mr-1 ojo"
                  *ngIf="!isPassword"
                  (click)="showPassword()"
                ></span>
                <span class="fas fa-lock"></span>
              </div>
            </div>
          </div>

          <div class="d-grid gap-2 mt-4 mb-4">
            <button
              class="btn btn-primary d-flex justify-content-center"
              type="submit"
              [disabled]="loginForm.invalid || isLoading"
              (click)="login()"
            >
              <ng-container *ngIf="!isLoading; else spinner">
                Iniciar Sesión
              </ng-container>
            </button>
            <ng-template #spinner>
              <mat-spinner diameter="20"></mat-spinner>
            </ng-template>
          </div>
        </form>
      </div>
    </div>
    <div class="splash-footer text-center">
      <span class="card-subtitle mb-2 text-muted" style="font-size: 12px"
        >Todos los derechos reservados © 2023.</span
      >
    </div>
  </div>
</div>
